<template>
  <div>
    <!-- <euros-header :titre="`Résultats`" btnRetour="Liste" pathRetour="/patients"></euros-header> -->
    <div class="position-relative w-100">
      <div class="position-absolute" style="z-index: 2000; top: 10px; right: 10px">
        <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon" @click="finish"
          style="width: 30px; height: 30px; min-height: 0">
          <icon width="20" height="20" name="times"></icon>
        </div>
        <div @click="help" class="mt-3 aide pointer color-white d-flex flex-row align-items-left justify-content-start"
          style="background-color:white; border-radius: 50%;">
          <icon width="30" height="30" name="question-circle" class="" color="#a2acbf"></icon>
        </div>
      </div>

      <div v-if="zoomedFile && showZoom" class="position-fixed d-flex justify-content-center align-items-center post-op-zoom" @click="showZoom = false">
        <div class="zoomed-image" @click.stop>
          <img
            :src="$config.server_url + '/api/1.0/files/patient/' + $route.params.id + '/' + zoomedFile.fi_id + '?token=' + $store.state.accesstoken + '&origin=webapp'"
            alt="Radio post-opératoire agrandie"
            class="img-fluid"
          />
          <button class="close-zoom" type="button" aria-label="Fermer" @click="showZoom = false">
            <icon width="24" height="24" name="times" color="black"></icon>
          </button>
        </div>
      </div>

    </div>
    <div class="container-fluid bg-blue">
      <div class="row">
        <div class="col pt-5 pb-4">
          <h1>ACTIVITÉS</h1>
          <h2>HANCHE</h2>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="relative bg-dark gestoparent" ref="gestoparent" style="flex-grow: 1; height: 300px">
            <div style="height: 100%; position: relative" ref="gesto">
              <div style="position: absolute" ref="bgimage">
                <img ref="imgRadio" class=""
                  :src="$config.server_url + '/api/1.0/files/patient/' + $route.params.id + '?token=' + $store.state.accesstoken + '&origin=webapp'"
                  alt="test" @load="imageLoaded" />
              </div>
              <div class="cotyleimage position-absolute" data-image="cotyle" ref="cotyleimage">
                <div class="cotyleimagecontent" ref="cotyleimagecontent">
                  <img v-if="patient.pa_cotyle" ref="imgCotyle" class="" :src="$config.server_url +
                    '/api/1.0/products/' +
                    patient.pa_cotyle.pr_id +
                    '/images/' +
                    numImage +
                    '?lateralite=' +
                    patient.pa_lateralite +
                    '&token=' +
                    $store.state.accesstoken +
                    '&origin=webapp'
                    " alt="test" />
                </div>
              </div>
              <div class="tigeimage position-absolute" data-image="tige" ref="tigeimage">
                <div class="tigeimagecontent" ref="tigeimagecontent">
                  <img v-if="patient.pa_tige" ref="imgTige" class="" :src="$config.server_url +
                    '/api/1.0/products/' +
                    patient.pa_tige.pr_id +
                    '/images/' +
                    numImage +
                    '?lateralite=' +
                    patient.pa_lateralite +
                    '&token=' +
                    $store.state.accesstoken +
                    '&origin=webapp'
                    " alt="test" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row pt-2">
        <div class="col d-flex align-items-center justify-content-between mb-2 mb-sm-0">
          <div class="ml-3 text-right">
            <button @click="editProthesis" class="btn btn-primary mr-3">
              <icon width="16" height="16" name="arrow-circle-left" class="mr-2" color="" style="margin-bottom: -2px"> </icon>Modifier
            </button>
            <button @click="print" class="btn btn-primary mr-3">Imprimer</button>
          </div>
        </div>
      </div> -->
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="float-right mt-2">
            <div @click="print" class="rounded-circle d-flex align-items-center justify-content-center btn-icon" style="margin-top:-15px;width: 30px; height: 30px"><icon class="" name="print"></icon></div>
            
          </div>
          <h3 class="mb-3">Patient</h3>
          <div class="float-right mt-0">
            <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon"
              style="width: 30px; height: 30px" @click="editProthesis(3)">
              <icon class="" name="pen"></icon>
            </div>
          </div>
          <h2 class="mb-1">{{ patient.pa_name }} <span class="date"></span></h2>
          <div>
            <span v-if="patient.pa_sex > 0">
              <span v-if="patient.pa_sex == 1">Homme | </span>
              <span v-if="patient.pa_sex == 2">Femme | </span>
            </span>
            <span v-if="age > 0">
              {{ age }}&nbsp;ans |
              <!-- <span style="font-size: 0.7rem">(Né(e) le {{$dayjs(patient.pa_birthdate).format("DD/MM/YYYY") }})</span> -->
            </span>
            <span v-if="patient.pa_weight">{{ patient.pa_weight }}&nbsp;Kg | </span>
            <span v-if="patient.pa_height">{{ patient.pa_height }}&nbsp;cm | </span>
            <span v-if="patient.pa_lateralite">
              <span v-if="patient.pa_lateralite == 'right'">Côté droit</span>
              <span v-if="patient.pa_lateralite !== 'right'">Côté gauche</span>
            </span>
            <br />
            <span v-if="patient.pa_dateoperation">
              <span class="date">Date opératoire G0 : {{ $dayjs(patient.pa_dateoperation).format("DD/MM/YYYY") }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-lg-4">
          <!-- <div class="mb-2">
            <table class="my-2 table-delta">
              <thead>
                <tr>
                  <th>Cols</th>
                  <th>Offset</th>
                  <th>Long.</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Col S</td>
                  <td>{{ patient.pa_delta_min_x | formatDelta }}&nbsp;mm</td>
                  <td>{{ patient.pa_delta_min_y | formatDelta }}&nbsp;mm</td>
                </tr>
                <tr>
                  <td>Col M</td>
                  <td>{{ patient.pa_delta0_x | formatDelta }}&nbsp;mm</td>
                  <td>{{ patient.pa_delta0_y | formatDelta }}&nbsp;mm</td>
                </tr>
                <tr>
                  <td>Col L</td>
                  <td>{{ patient.pa_delta_max_x | formatDelta }}&nbsp;mm</td>
                  <td>{{ patient.pa_delta_max_y | formatDelta }}&nbsp;mm</td>
                </tr>
              </tbody>
            </table>
          </div> -->
        </div>

        <div class="col-lg-8">
          <!-- <h4>Cotyle et tige choisies</h4> -->
          <!-- <h6 class="mb-0 mt-3">COTYLE ET TIGE</h6> -->
          <div class="line-product bt d-flex justify-content-between align-items-center border-bottom"
            style="border-top: 0px solid white" v-if="patient.pa_cotyle">
            <div class="d-flex align-items-center w-100">
              <!-- <img v-if="true" class="img-product" :src="$config.server_url +
                '/api/1.0/products/' +
                patient.pa_cotyle.pr_id +
                '/images/' +
                numImage +
                '?token=' +
                $store.state.accesstoken +
                '&origin=webapp'
                " alt="" /> -->
              <div class="container-img-product">
                <!-- repli sur l'image générique tant que l'image du produit n'est pas fournie -->
                <img :src="'/images/' + (patient.pa_cotyle.pr_image_final || 'cupule-01.png')" class="img-product" alt="">
              </div>

              <div class="ml-3 flex-grow-1">
                <div class="float-right">
                  <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon"
                    style="width: 30px; height: 30px" @click="editProthesis(1)">
                    <icon class="" name="pen"></icon>
                  </div>
                </div>
                <strong>Cotyle choisie :</strong><br />
                {{ patient.pa_cotyle.pr_model }} {{ patient.pa_cotyle.pr_subtype }}<br />
                Mat. {{ patient.pa_cotyle.pr_matiere }}<br>
                Diam. {{ patient.pa_cotyle.pr_size }} mm
                <!-- <span v-html="patient.pa_cotyle.pr_name"></span><br /> -->
                <!-- <label class="m-form-checkbox">
                    <input type="checkbox" v-model="patient.pa_cotyle_used" @change="saveUsed" />
                    J'ai utilisé ce cotyle
                  </label> -->
              </div>
            </div>
          </div>
          <div class="line-product d-flex justify-content-between align-items-center border-bottom"
            v-if="patient.pa_tige">
            <div class="d-flex align-items-center w-100">
              <!-- <img v-if="true" class="img-product" :src="$config.server_url +
                '/api/1.0/products/' +
                patient.pa_tige.pr_id +
                '/images/' +
                numImage +
                '?token=' +
                $store.state.accesstoken +
                '&origin=webapp'
                " alt="" /> -->
              <div class="container-img-product">
                <img :src="'/images/' + (patient.pa_tige.pr_image_final || 'tige.png')" class="img-product" alt="">
              </div>

              <div class="ml-3 flex-grow-1">
                <div class="float-right">
                  <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon"
                    style="width: 30px; height: 30px" @click="editProthesis(2)">
                    <icon class="" name="pen"></icon>
                  </div>
                </div>
                <strong>Tige choisie :</strong><br />
                {{ patient.pa_tige.pr_model }} {{ patient.pa_tige.pr_subtype }}<br />
                Mat. {{ patient.pa_tige.pr_matiere }}<br>
                Taille {{ patient.pa_tige.pr_size }} mm
                <!-- {{ patient.pa_tige.pr_name }}<br /> -->
                <!-- <span v-html="patient.pa_tige.pr_name"></span><br /> -->
                <!-- <label class="m-form-checkbox">
                    <input type="checkbox" v-model="patient.pa_tige_used" @change="saveUsed" />
                    J'ai utilisé cette tige
                  </label> -->
              </div>
            </div>
          </div>

          <div class="line-product d-flex justify-content-between align-items-center" v-if="patient.pa_tige">
            <div class="d-flex align-items-center w-100">
              <!-- <img v-if="true" class="img-product" :src="$config.server_url +
                '/api/1.0/products/' +
                patient.pa_tige.pr_id +
                '/images/' +
                numImage +
                '?token=' +
                $store.state.accesstoken +
                '&origin=webapp'
                " alt="" /> -->
              <div class="container-img-product">
                <!-- l'image de la tête dépend de l'insert : elle est portée par le cotyle, pas par la tige -->
                <img :src="'/images/' + (imageTete || 'tete-01.png')" class="img-product" alt="">
              </div>

              <div class="ml-3 flex-grow-1">

                <strong>Tête fémorale :</strong><br />
                {{ patient.pa_tige.pr_tete }} mm<br>
                S (-3,5mm) / M (0mm) / L (+3,5mm)
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <h6 class="mb-0">REMARQUES</h6>
          <div v-if="!editComment">
            <div class="float-right">
              <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon"
                style="width: 30px; height: 30px" @click="editComment = true">
                <icon class="" name="pen"></icon>
              </div>
            </div>
            <div class="mb-1" v-html="nl2br(patient.pa_comment)"></div>
          </div>
          <div v-else class="text-right">
            <textarea name="pa_comment" style="width: 100%" id="" cols="30" rows="5"
              v-model="patient.pa_comment"></textarea>
            <button class="btn btn-primary mt-2" @click="saveComment">Valider</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <hr style="height: 3px; border-top: 4px dotted #333;" />
          <h3 class="mb-0">Post opératoire</h3>
          <div class="post-op-help"><strong>Radios</strong> peut être au format : .DICOM, .JPEG / .JPG, .PNG</div>
          <div class="post-op-slots">
            <div v-for="slot in 2" :key="slot" class="post-op-slot-row">
              <div class="post-op-slot">
                <template v-if="postOpFile(slot)">
                  <img
                    class="post-op-image"
                    :src="
                      $config.server_url +
                        '/api/1.0/files/patient/' +
                        $route.params.id +
                        '/' +
                        postOpFile(slot).fi_id +
                        '?token=' +
                        $store.state.accesstoken +
                        '&origin=webapp'
                    "
                    :alt="'Radio post-opératoire ' + slot"
                    @click="zoom(postOpFile(slot))"
                  />
                  <button class="btn btn-secondary post-op-delete" type="button" @click="deletePostOpFile(postOpFile(slot))">Supprimer</button>
                </template>
                <template v-else>
                  <button class="btn btn-primary post-op-add" type="button" :disabled="uploadingSlot !== null" @click="changefile(slot)">
                    <icon color="white" name="file-image" class="mr-2"></icon>{{ uploadingSlot === slot ? "Envoi…" : "+ fichier" }}
                  </button>
                  <input
                    hidden
                    type="file"
                    :ref="'inputfile' + slot"
                    :name="'inputfile' + slot"
                    accept="image/*, application/dicom"
                    @change="inputFileChange($event, slot)"
                  />
                </template>
              </div>
            </div>
          </div>


          <div>
            <div v-if="!editComment2">
              <div class="float-right">
                <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon"
                  style="width: 30px; height: 30px" @click="editComment2 = true">
                  <icon class="" name="pen"></icon>
                </div>
              </div>
              <div class="mb-1" v-html="nl2br(patient.pa_comment2)"></div>
            </div>
            <div v-else class="text-right">
              <textarea name="pa_comment2" style="width: 100%" id="" cols="30" rows="5" v-model="patient.pa_comment2"
                placeholder="Commentaire post-opératoire"></textarea>
              <button class="btn btn-secondary mt-2" @click="saveCommentAndClose">Enregistrer</button>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row mt-3">
        <div class="col-lg-8 offset-lg-4">
          <m-form-checkbox
            class="mb-0 mt-3"
            v-model="savePreferences"
            label="En cochant cette case vos futures utilisations intégreront par défaut ces données : "
            name="savePreferences"
          ></m-form-checkbox>
          <div style="" class="ml-3" v-if="patient.pa_cotyle">
            - Cotyle : {{ patient.pa_cotyle.pr_name }}<br />
            - Tige : {{ patient.pa_tige.pr_name }} <br />
            - Taille de la bille : {{ patient.pa_toolsballsize }}mm
          </div>
        </div>
      </div> -->
      <div class="row mt-4">
        <div class="col-lg-8 offset-lg-4 d-flex justify-content-between mb-3">
          <div>
            <!-- <button @click="editProthesis" class="btn btn-primary mr-3">
                <icon width="16" height="16" name="arrow-circle-left" class="mr-2" color="" style="margin-bottom: -2px"></icon>Modifier
              </button> -->
            <!-- <button @click="print" class="btn btn-primary mr-3">Imprimer</button> -->
          </div>
          <!-- <div>
              <button @click="finish" class="btn btn-primary mr-3">Terminer</button>
            </div> -->
        </div>
      </div>
      <!-- <div class="row py-5">
        <div class="col-lg-4"></div>
        <div class="col">
          <h4>Questionnaire de MMC</h4>
          <div class="my-3">Vous pouvez nous aider en répondant à ce questionnaire sur une échelle de 1 à 5</div>
          <div class="questionnaire-line">
            <div>Q1 : Sur une échelle de 1 à 5, à combien évaluez-vous la performance de l'application (temps de réponse &amp; accès) ?</div>
            <div>
              <select class="custom-select" style="max-width: 300px" v-model="patient.pa_answer1" @change="saveUsed">
                <option selected>Choisir</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
            </div>
          </div>
          <div class="questionnaire-line">
            <div>
              Q2 : Sur une échelle de 1 à 5, à combien évaluez-vous l'ergonomie de l'application (placement des calques d'implant / navigation dans
              l'application) ?
            </div>
            <div>
              <select class="custom-select" style="max-width: 300px" v-model="patient.pa_answer2" @change="saveUsed">
                <option value="0">Choisir</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
            </div>
          </div>
          
          <div class="questionnaire-line">
            <div>Q3 : Conseilleriez-vous l'application à un confrère ?</div>
            <div>
              <select class="custom-select" style="max-width: 300px" v-model="patient.pa_answer4" @change="saveUsed">
                <option value="0">Choisir</option>
                <option value="1">Oui</option>
                <option value="2">Non</option>
              </select>
            </div>
          </div>
          <div class="questionnaire-line">
            <div>Q4 : Exprimez-vous !</div>
            <div>
              <textarea name="pa_answer5" style="width: 100%" id="" cols="30" rows="5" v-model="patient.pa_answer5" @input="saveUsed"></textarea>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-lg-8 offset-lg-4 d-flex justify-content-between mb-3">
              <div>&nbsp;</div>
              <div>
                <button @click="finish" class="btn btn-primary mr-3">Terminer</button>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="winmodal" v-if="$store.state.help.result"></div>
    <div class="helpwin" v-if="$store.state.help.result">
      <div class="winclose">
        <label for="notdisplayanymore" style="margin: -5px 30px"><input type="checkbox" id="notdisplayanymore"
            v-model="notdisplayanymore" />Ne plus afficher</label>
        <a href="javascript:void(0);" @click="$store.commit('set_help', ['result', notdisplayanymore])">
          <icon width="24" height="24" name="times" class="" color="black"></icon>
        </a>
      </div>
      <div class="row">
        <div class="col-md-8">
          <h3>Explication des « delta longueur et offset ».</h3>
          <p>
            Les « delta longueur et offset » représentent les distances suivant l’axe de la tige et sa perpendiculaire
            entre le centre tête défini par
            le positionnement de la tige et celui défini par l’implant acétabulaire (distance cranio caudale pour la
            longueur et distance latérale
            pour l’offset).
          </p>
          <div>
            <button class="btn btn-primary" @click="clickHelp">SUIVANT</button>
          </div>
        </div>
        <div class="col-md-4">
          <img src="/images/aide/schemadelta.jpeg" class="img-fluid" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "result",
  components: {},
  data() {
    return {
      notdisplayanymore: false,
      pa_id: this.$route.params.id,
      patient: {},
      savePreferences: false,
      age: 0,

      tx: 0,
      ty: 0,
      scale: 1,
      numImage: "1r",
      imgRealLoaded: false,
      nbOfMmOf100pxOfCotyle: 20,

      editComment: true,
      editComment2: true,
      uploadingSlot: null,
      zoomedFile: null,
      showZoom: false
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    this.$store.dispatch("addHistoryUrl", this.$route.path);
    await this.loadTree();
    await this.loadPatient();
  },
  watch: {},
  computed: {
    // l'image de la tête est portée par le cotyle (elle dépend de l'insert), alors que ce bloc
    // s'affiche dès qu'il y a une tige : le cotyle peut donc être absent
    imageTete() {
      return this.patient.pa_cotyle ? this.patient.pa_cotyle.pr_image_final_tete : "";
    }
  },
  methods: {
    zoom(file) {
      this.zoomedFile = file;
      this.showZoom = true;
    },
    help() {
      window.open(this.$config.server_url + "/api/1.0/files/help" + "?token=" + this.$store.state.accesstoken + "&origin=webapp", "_blank");
    },
    postOpFile(slot) {
      let fiWhere = slot === 1 ? "postoperatoire" : "postoperatoire2";
      return (this.patient.files || []).find(file => file.fi_where === fiWhere);
    },
    changefile(slot) {
      this.$refs["inputfile" + slot][0].click();
    },
    async inputFileChange(e, slot) {
      // let maxWait = 3000,
      //   time = new Date();
      if (!e.target.files.length) return;

      this.uploadingSlot = slot;
      let file = e.target.files[0];
      let formdata = new FormData();
      formdata.append("file", file);
      formdata.append("pa_id", this.patient.pa_id);
      formdata.append("fi_where", slot === 1 ? "postoperatoire" : "postoperatoire2");

      try {
        this.cancelTokenSource = this.$axios.CancelToken.source();
        await this.$axios.post(this.$config.server_url + "/api/1.0/files2", formdata, {
          cancelToken: this.cancelTokenSource.token,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        // let towait = maxWait - (new Date() - time);
        // // console.log("towait", towait);
        // if (towait > 0) {
        //   await new Promise(accept => {
        //     window.setTimeout(() => {
        //       accept();
        //     }, towait);
        //   });
        // }
        // console.log("time-new Date()", new Date() - time);
        // if (response.data.data.ext == ".dcm") this.$router.push("/prosthesis/" + response.data.data.patientId + "/1").catch(err => {});
        // else this.$router.push("/ratio/" + response.data.data.patientId).catch(err => {});
        await this.loadPatient();
      } catch (error) {
        alert("Le format de l'image n'est pas pris en charge.");
      } finally {
        this.uploadingSlot = null;
        e.target.value = "";
      }
    },
    async deletePostOpFile(file) {
      if (!window.confirm("Souhaitez-vous supprimer cette image ?")) return;
      await this.$axios.delete(this.$config.server_url + "/api/1.0/files/patient/" + this.patient.pa_id + "/" + file.fi_id);
      await this.loadPatient();
    },
    async changeSelectProduct(type, select, sens = "") {
      // console.log("this.tige_productSelected", this.tige_productSelected.pr_size);
      // on garde la taille en mémoire
      let size;
      if (this[type + "_productSelected"]) {
        size = this[type + "_productSelected"].pr_size;
      }
      // console.log("size", size);
      // on met les v-model à null et on appelle defineSelectProduct() pour redeffinir tous les selects
      if (select !== "size") {
        this[type + "_productSelected"] = null;
        if (select === "model") {
          this[type + "_subtype"] = null;
          // if (type === "tige") this.tige_col = null;
          this[type + "_col"] = null;
        }
        if (select === "subtype") {
          // && type === "tige"
          // this.tige_col = null;
          this[type + "_col"] = null;
        }
        this.defineSelectProduct(type, size);
      } else {
        this.defineSelectProduct(type, size);
        let indexSize = this.$_.findIndex(this["items_" + type + "_size"], { key: this[type + "_productSelected"].pr_size });
        if (indexSize >= 0) {
          if (sens === "plus" && indexSize < this["items_" + type + "_size"].length - 1) {
            this[type + "_productSelected"] = this["items_" + type + "_size"][indexSize + 1].product;
          }
          if (sens === "moins" && indexSize > 0) this[type + "_productSelected"] = this["items_" + type + "_size"][indexSize - 1].product;
        }
      }
      this.saveUsed();
    },
    async loadTree() {
      // route qui récupère tous les produits triés par models, subtype, col et size  sous forme d'arbre
      let response = await this.$axios.get(this.$config.server_url + "/api/1.0/products/tree", {
        params: {}
      });
      this.productsTree = response.data.data;
      this.items_cotyle_model = this.productsTree[0].items;
      this.items_tige_model = this.productsTree[1].items;
      // console.log("this.productsTree", this.productsTree);
    },
    clickHelp() {
      this.$store.commit("set_help", ["result", this.notdisplayanymore]);
    },
    print() {
      window.open(
        this.$config.server_url +
        "/api/1.0/patients/" +
        this.pa_id +
        "/print" +
        "?token=" +
        this.$store.state.accesstoken +
        "&origin=webapp" +
        "&d=" +
        new Date().getTime()
      );
    },
    async loadPatient() {
      let response = await this.$axios.get(this.$config.server_url + "/api/1.0/patients/" + this.pa_id);
      this.patient = response.data.data;
      // console.log("this.patient", this.patient);
      if (this.patient.pa_answer1 == "") this.patient.pa_answer1 = "0";
      if (this.patient.pa_answer2 == "") this.patient.pa_answer2 = "0";
      if (this.patient.pa_answer3 == "") this.patient.pa_answer3 = "0";
      if (this.patient.pa_answer4 == "") this.patient.pa_answer4 = "0";
      if (this.patient.pa_birthdate != "0000-00-00") this.age = dayjs().diff(dayjs(this.patient.pa_birthdate), "year");
      else this.age = 0;
      if (this.patient.pa_lateralite == "right") {
        this.numImage = "1r";
      } else {
        this.numImage = "1l";
      }
      if (this.patient.pa_cotyle) {
        this.patient.pa_cotyle.pr_name = this.patient.pa_cotyle.pr_name.replace(/ \-/g, "<br>");
      }
      if (this.patient.pa_tige) {
        this.patient.pa_tige.pr_name = this.patient.pa_tige.pr_name.replace(/ \-/g, "<br>");
      }
      if (this.patient.pa_comment) {
        this.editComment = false;
      } else {
        this.editComment = true;
      }
      if (this.patient.pa_comment2) {
        this.editComment2 = false;
      } else {
        this.editComment2 = true;
      }
      this.imageRealLoaded();
      // console.log("patient.createdAt", this.patient);
    },
    newPatient() {
      this.$router.push("/chooseimage").catch(err => {});
    },
    editProthesis(num) {
      if (num == 3) {
        this.$router.push("/infos/" + this.pa_id).catch(err => {});
        return;
      }
      this.$router.push("/prosthesis/" + this.pa_id + "/" + num).catch(err => {});
    },
    async saveComment() {
      await this.$axios.put(this.$config.server_url + "/api/1.0/patients/" + this.patient.pa_id, {
        pa_comment: this.patient.pa_comment,
        pa_comment2: this.patient.pa_comment2
      });
      if (this.patient.pa_comment) this.editComment = false;
      if (this.patient.pa_comment2) this.editComment2 = false;
    },
    async saveCommentAndClose() {
      await this.saveComment();
      this.finish();
    },
    async saveUsed() {
      await this.$axios.put(this.$config.server_url + "/api/1.0/patients/" + this.patient.pa_id, {
        // pa_cotyle_used: this.patient.pa_cotyle_used,
        // pa_tige_used: this.patient.pa_tige_used,
        pa_answer1: this.patient.pa_answer1,
        pa_answer2: this.patient.pa_answer2,
        pa_answer3: this.patient.pa_answer3,
        pa_answer4: this.patient.pa_answer4,
        pa_answer5: this.patient.pa_answer5
      });
    },
    async finish() {
      // on enregistre les préférences si la checkbox est cochée
      // if (this.savePreferences) {
      //   let products = {
      //     pr_id_cotyle: this.patient.pa_cotyle.pr_id,
      //     pr_id_tige: this.patient.pa_tige.pr_id,
      //     co_ballsize: this.patient.pa_toolsballsize
      //   };
      //   await this.$axios.put(this.$config.server_url + "/api/1.0/contacts/" + this.$store.state.user.co_id + "/preferences", products);
      // }
      this.$router.push("/patients").catch(err => {});
    },

    drawElements() {
      let wContainer = this.$refs.gestoparent.offsetWidth,
        hContainer = this.$refs.gestoparent.offsetHeight;
      // console.log("🚀 ~ drawElements ~ wContainer:", wContainer, hContainer);
      let toW = wContainer / 2 - this.tx;
      let toH = hContainer / 2 - this.ty;
      this.$refs.gesto.style.transformOrigin = `${toW}px ${toH}px`;
      this.$refs.gesto.style.transform = `translate(${this.tx}px, ${this.ty}px) scale(${this.scale})`;
    },
    centerBgImage() {
      let wContainer = this.$refs.gestoparent.offsetWidth,
        hContainer = this.$refs.gestoparent.offsetHeight,
        wImage = this.$refs.bgimage.offsetWidth,
        hImage = this.$refs.bgimage.offsetHeight;
      if (wContainer / wImage > hContainer / hImage) {
        this.scale = wContainer / wImage;
        this.ty = (hContainer - hImage) / 2;
        this.tx = (wImage * this.scale - wImage) / 2;
      } else {
        this.scale = hContainer / hImage;
        this.tx = (wContainer - wImage) / 2;
        this.ty = (hImage * this.scale - hImage) / 2;
      }
      // console.log("🚀 ~ centerBgImage ~ this.scale:", this.scale);
      // console.log("this.tx", this.tx, wContainer, wImage, (wContainer - hContainer) / 2);
      // let toW = wContainer / 2 - this.tx;
      // let toH = hContainer / 2 - this.ty;
      // this.$refs.gesto.style.transformOrigin = `${toW}px ${toH}px`;
      // this.$refs.gesto.style.transform = `translate(${this.tx}px, ${this.ty}px) scale(${this.scale})`;
      this.drawElements();
    },
    placeElements(type) {
      let scaleElements = this.nbOfMmOf100pxOfCotyle / (this.patient.pa_toolsscale * this.patient.pa_toolsballsize);
      let rl = this.patient.pa_lateralite == "right" ? "r" : "l";
      if (this.$refs[type + "image"]) {
        this.$refs[type + "image"].style.left = `${this.patient["pa_" + type + "_img_offsetx"]}px`;
        this.$refs[type + "image"].style.top = `${this.patient["pa_" + type + "_img_offsety"]}px`;
        this.$refs[type + "image"].style.transform = `scaleX(${scaleElements}) scaleY(${scaleElements}) rotate(${this.patient["pa_" + type + "_img_rotateangle"]
          }deg)`;
        this.$refs[type + "image"].style.transformOrigin = `${this.patient["pa_" + type]["pr_rotationcenter_x_" + rl] * 1}px ${this.patient["pa_" + type]["pr_rotationcenter_y_" + rl] * 1
          }px`;
      }
    },
    nl2br(str) {
      if (typeof str === "undefined" || str === null) {
        return "";
      }
      return (str + "").replace(/(\r\n|\n\r|\r|\n)/g, "<br>");
    },
    imageLoaded(e) {
      this.imgRealLoaded = true;
      this.imageRealLoaded();
    },
    imageRealLoaded() {
      if (!this.imgRealLoaded || !this.patient || !this.patient.pa_tige) return;
      // console.log("imageRealLoaded");
      this.$nextTick(() => {
        // console.log("image loaded", this.patient);
        this.centerBgImage();
        this.drawElements();
        this.placeElements("cotyle");
        this.placeElements("tige");
        // this.defineSelectProduct("cotyle");
        // this.defineSelectProduct("tige");
        // console.warn("image loaded");
      });
    }
  }
};
</script>

<style scoped lang="scss">
.m-form-checkbox {
  margin-bottom: 0;
}

.bt {
  border-top: 1px solid #cacaca;
}

.line-product {
  padding: 20px 0;
  // border-bottom: 1px solid #cacaca;
}

.img-product {
  width: 80px;
  height: 80px;
  min-width: 80px;
  min-height: 80px;
  object-fit: contain;
  object-position: center;
}

.container-img-product {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: #d5d5d5;
}

.date {
  font-weight: 400;
}

.questionnaire-line {
  padding-bottom: 25px;
}

.post-op-help {
  margin-top: 8px;
  font-size: 0.9rem;
}

.post-op-slots {
  margin-top: 12px;
}

.post-op-slot-row {
  border-bottom: 1px solid #e5e5e5;
}

.post-op-slot {
  display: flex;
  min-height: 82px;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 14px 2px;
}

.post-op-add,
.post-op-delete {
  border-radius: 22px;
}

.post-op-delete {
  margin-top: 8px;
}

.post-op-image {
  width: 150px;
  height: 150px;
  object-fit: contain;
  cursor: pointer;
}

.post-op-zoom {
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.8);
}

.post-op-zoom .zoomed-image {
  position: relative;
  max-width: 95vw;
  max-height: 95vh;
}

.post-op-zoom img {
  max-height: 90vh;
  object-fit: contain;
}

.post-op-zoom .close-zoom {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: white;
  cursor: pointer;
}

.bgimage,
.cotyleimage,
.tigeimage {
  position: absolute;
}

.cotyleimage {
  // position: relative;
  // pour mettre la couleur verte
  filter: invert(1) grayscale(100%) brightness(40%) sepia(100%) hue-rotate(50deg) saturate(1000%) contrast(0.8);
  width: 300px;
  height: 300px;
  overflow: hidden;
}

.tigeimage {
  // position: relative;
  // pour mettre la couleur rouge
  filter: invert(1) grayscale(100%) brightness(40%) sepia(100%) hue-rotate(-50deg) saturate(600%) contrast(0.8);
  width: 400px;
  height: 1000px;
  overflow: hidden;
}

.cotyleimagecontent {
  position: absolute;
  top: 0px;
  left: 0px;
}

.tigeimagecontent {
  // transform-origin: 1px 1px;
  position: absolute;
  top: 0;
  left: 0;
}

.gestoparent {
  overflow: hidden;
  border-radius: 15px;
}

.btn-icon {
  background-color: #c6091f;
  color: white;

  &.disabled {
    background-color: #a7a7a7;
  }
}
</style>
